<template>
  <div id="parking">
      <TicketFilter @submit-filters="getTickets"/>
      <Tickets :tickets="resultTickets" v-show="showRows" @del-ticket="deleteTicket" />
  </div>
</template>

<script>

import axios from 'axios'
import Tickets from './Tickets.vue'
import TicketFilter from './TicketFilter.vue'

export default {
	name: 'ParkingOverview',
	components: {
		TicketFilter,
		Tickets,
	},
	data() {
		return {
			tickets: [],
			showRows: false,
			resultTickets: [],
			noResult: false,
			loadingData: false,
		}
	},
	methods: {
		deleteTicket(id) {
			this.resultTickets = this.resultTickets.filter((ticket) => ticket.id != id)
		},
		filterData(filterOptions) {
			this.resultTickets = [...this.resultTickets, filterOptions]
		},
		async getTickets(filterOptions) {
			this.loadingData = true
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/parking-report/tickets?filterDate=${filterOptions.date}`)
				this.resultTickets = res.data
				if (res.data.length <= 0) this.noResult = true
				this.loadingData = false
				this.showRows = true
			} catch (e) {
				console.log(e)
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getTickets()
		})
	},
}
</script>

<style>

</style>
